import * as React from 'react';
import { memo } from 'react';

import Link from 'components/atoms/Link';
import { LinkProps } from 'components/atoms/Link';

export type LinkListEntryType = {
	icon?: string;
} & LinkProps;

export type LinkListProps = {
	modifier?: string;
	links: LinkListEntryType[];
};

export const LinkList = ({ links = [], modifier }: LinkListProps) => {
	return (
		<ul className={`m-link-list${modifier ? ` m-link-list--${modifier}` : ''}`}>
			{links &&
				links.map((link: LinkListEntryType = {}, index: number) => {
					return (
						<li key={`link-item-${index}-${links.length}`} className="m-link-list__item">
							<Link
								disabled={link.disabled}
								modifier={link.modifier}
								iconLeft={link.icon}
								title={link.title}
								href={link.href}
								externalHref={link.externalHref}
								onClick={link.onClick}
								openInNewWindow={link.openInNewWindow}
								withoutIcon={link.withoutIcon}
							/>
						</li>
					);
				})}
		</ul>
	);
};

LinkList.displayName = 'LinkList';

export default memo(LinkList);
